import script from "./ExpressCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpressCompanies.vue?vue&type=script&setup=true&lang=js"

import "./ExpressCompanies.vue?vue&type=style&index=0&id=3c1eeb6d&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1eeb6d"]])

export default __exports__